import { Panel } from "@/components/KpiCard";
import { SmartTable } from "@/components/SmartTable";
import { moisLabel, money } from "@/lib/api";

export const FraisBookingPanel = ({ frais }) => {
  if (!frais?.nb) { return null; }
  const mois = frais.mois.filter((m) => m.nb);
  return (
    <Panel title={`Frais de paiement retenus par Booking (${money(frais.total)})`} testId="bilan-frais-booking-panel">
      <p className="mb-3 text-xs text-slate-500">
        Différence entre le versement attendu (prix + TPS + TVQ) et le dépôt bancaire Booking, sur les dépôts rapprochés.
        Dépense déductible, déjà comptée dans les charges de chaque logement (« Frais de paiement Booking »).
      </p>
      <div className="overflow-x-auto -mx-5">
        <SmartTable id="frais-booking" data-export-titre="Frais Booking" className="w-full min-w-[420px] text-sm" data-testid="bilan-frais-booking-table">
          <thead>
            <tr className="text-[11px] font-mono uppercase tracking-wider text-slate-500">
              <th className="px-3 py-2 text-left">Mois du dépôt</th><th className="px-3 py-2 text-right">Dépôts Booking</th><th className="px-3 py-2 text-right">Frais retenus</th>
            </tr>
          </thead>
          <tbody>
            {mois.map((m) => (
              <tr key={m.mois} className="border-t border-slate-100" data-testid={`bilan-frais-booking-${m.mois}`}>
                <td className="px-3 py-2.5 font-medium capitalize">{moisLabel(m.mois)}</td>
                <td className="px-3 py-2.5 text-right tabular">{m.nb}</td>
                <td className="px-3 py-2.5 text-right tabular">{money(m.montant)}</td>
              </tr>
            ))}
            <tr className="border-t border-slate-200 bg-slate-50 font-semibold" data-st-fixe="" data-testid="bilan-frais-booking-total">
              <td className="px-3 py-2.5">Total</td><td className="px-3 py-2.5 text-right tabular">{frais.nb}</td><td className="px-3 py-2.5 text-right tabular">{money(frais.total)}</td>
            </tr>
          </tbody>
        </SmartTable>
      </div>
    </Panel>
  );
};
